import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfileData,
  updateProfileData,
} from "~/store/ducks/colaboratorProfile/actionTypes";
import { withNamespaces } from "react-i18next";
import Messages from "~/components/Messages";
import { Row, Col, Form } from "react-bootstrap";
import ButtonsUpdate from "./ButtonsUpdate";
import Dropdown from "~/components/Dropdown";
import DateTimePicker from "react-datetime-picker";
import Image from "react-bootstrap/Image";
import DefaultAvatar from "~/assets/img/avatar/avatar-default.png";

const RHProfile = ({ rowCollaborator, t }) => {
  const dispatch = useDispatch();

  const { profileData, setUpdateProfileData } = useSelector(
    (state) => state.colaboratorProfileReducer
  );

  const [formData, setFormData] = useState({
    selectedAvatar: "",
    selectedDescription: "",
  });
  const [formDataError, setFormDataError] = useState({
    selectedDescriptionError: false,
    selectedAvatarError: false,
  });
  const [validated, setValidated] = useState(false);
  const [updateButtonClicked, setUpdateButtonClicked] = useState(false);
  const [isClickedBtnUpdate, setIsClickedBtnUpdate] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [profileDataPage, setProfileDataPage] = useState(false);

  useEffect(() => {
    if (
      rowCollaborator &&
      Object.keys(rowCollaborator).length > 0 &&
      !setUpdateProfileData
    ) {
      dispatch(
        getProfileData(
          rowCollaborator.funcionarioNum,
          rowCollaborator.codEntidade
        )
      );
      setProfileDataPage(true);
    }
  }, [rowCollaborator, setUpdateProfileData]);

  useEffect(() => {
    if (Object.keys(profileData).length > 0) {
      const { foto, textoApresentacao } = profileData;
      setFormData((prevState) => ({
        ...prevState,
        selectedAvatar: foto || "",
        selectedDescription: textoApresentacao || "",
      }));
    } else {
      setFormData({
        selectedAvatar: "",
        selectedDescription: "",
      });
    }
  }, [profileData, rowCollaborator]);

  const handleChange = (field, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const OnTakingBolean = (data) => {
    setFormDataError({
      selectedDescriptionError: false,
      selectedAvatarError: false,
    });

    if (!data) {
      setIsClicked(true);
    }
    if (data) {
      setIsClicked(false);
    }
  };

  const updateData = (bollean) => {
    const payload = {
      foto: formData.selectedAvatar,
      textoApresentacao: formData.selectedDescription,
      lepNum: rowCollaborator.funcionarioNum,
      empCode: rowCollaborator.codEntidade,
    };
    setProfileDataPage(bollean);
    dispatch(updateProfileData(payload));
  };

  const handleUpdateButtonClicked = (bollean) => {
    if (!bollean) {
      setUpdateButtonClicked(true);
    }
    if (bollean) {
      setUpdateButtonClicked(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const initialErrors = {
      selectedDescriptionError: false,
      selectedAvatarError: false,
    };
    setFormDataError(initialErrors);

    const errors = {
      selectedDescriptionError:
        !formData.selectedDescription || formData.selectedDescription === "",
    };

    setFormDataError(errors);

    const hasError = Object.values(errors).some((error) => error);

    if (hasError) {
      setValidated(false);
      return;
    }

    setValidated(true);

    if (event.currentTarget.checkValidity()) {
      updateData(false);
      setIsClickedBtnUpdate(!isClickedBtnUpdate);
      OnTakingBolean(isClicked);
      handleUpdateButtonClicked(isClicked);
    }
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const maxSizeInBytes = 1 * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        setFormDataError((prevState) => ({
          ...prevState,
          selectedAvatarError: true,
        }));
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        handleChange("selectedAvatar", reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageRemove = () => {
    handleChange("selectedAvatar", "");
  };

  return (
    <div className="collaboratoRH__view">
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <ButtonsUpdate
          OnTakingBolean={OnTakingBolean}
          handleUpdateButtonClicked={handleUpdateButtonClicked}
          isClicked={isClickedBtnUpdate}
          setIsClicked={setIsClickedBtnUpdate}
        />
        <>
          <div
            className="d-flex"
            style={{ marginBottom: "20px", marginTop: "20px" }}
          >
            {/* Left side: Image */}
            <div
              className="image-section me-4 place-items-center"
              style={{ marginLeft: "1.5rem" }}
            >
              <Image
                src={formData.selectedAvatar || DefaultAvatar}
                rounded
                className="mb-3"
                height={"200px"}
              />
              <div className="d-flex align-items-center">
                <label
                  className="btn btn-primary me-2"
                  style={{
                    marginBottom: "0px",
                    cursor: isClicked ? "pointer" : "not-allowed",
                    color: "white",
                    backgroundColor: !isClicked ? "#e9ecef" : "#a9a9a9",
                  }}
                >
                  {t("portalrh.profileData.chooseFile")}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageUpload}
                    className="d-none"
                    disabled={!isClicked}
                    style={{ cursor: isClicked ? "pointer" : "not-allowed" }}
                  />
                </label>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleImageRemove}
                  disabled={!isClicked}
                  style={{
                    cursor: isClicked ? "pointer" : "not-allowed",
                  }}
                >
                  {t("portalrh.profileData.removeImage")}
                </button>
              </div>
              <Form.Control.Feedback
                type="invalid"
                style={{
                  display: formDataError.selectedAvatarError ? "block" : "none",
                }}
              >
                {`O ${t(
                  `portalrh.profileData.vatar`
                )} tem limite máximo de 1MB.`}
              </Form.Control.Feedback>
            </div>
            <div className="fields-section flex-grow-1 align-content-center">
              <Row>
                <Col xl="6" md="6">
                  <Form.Group controlId="validationCustom01">
                    <Form.Label className="rhcollaborator__labels">
                      {t(`portalrh.profileData.funcao`)}
                    </Form.Label>
                    <Form.Control
                      className={"collaboratorRH__FormControl2"}
                      type="text"
                      value={profileData.funcao || ""}
                      required
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
                <Col xl="6" md="6">
                  <Form.Group controlId="validationCustom01">
                    <Form.Label className="rhcollaborator__labels">
                      {t(`portalrh.profileData.departamento`)}
                    </Form.Label>
                    <Form.Control
                      className={"collaboratorRH__FormControl2"}
                      type="text"
                      value={profileData.departamento || ""}
                      required
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
                <Col xl="6" md="6">
                  <Form.Group controlId="validationCustom01">
                    <Form.Label className="rhcollaborator__labels">
                      {t(`portalrh.profileData.local_trabalho`)}
                    </Form.Label>
                    <Form.Control
                      className={"collaboratorRH__FormControl2"}
                      type="text"
                      value={profileData.localTrabalho || ""}
                      required
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
                <Col xl="6" md="6">
                  <Form.Group controlId="validationCustom01">
                    <Form.Label className="rhcollaborator__labels">
                      {t(`portalrh.profileData.data_admissao`)}
                    </Form.Label>
                    <DateTimePicker
                      value={profileData.dataAdmissao || ""}
                      locale="pt-PT"
                      format="dd/MM/yyyy"
                      className={"form-control"}
                      disabled={true}
                      clearIcon={null}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </div>

          <div
            className={isClicked ? "collaboratoRH__org2" : "collaboratoRH__org"}
          >
            <Col xl="12" md="12">
              <Form.Group controlId="validationCustom01">
                <Form.Label className="rhcollaborator__labels">
                  {t(`portalrh.profileData.descricao`)} <b>*</b>
                </Form.Label>
                <textarea
                  className="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  value={formData.selectedDescription || ""}
                  required
                  disabled={!isClicked}
                  onChange={(e) =>
                    handleChange("selectedDescription", e.target.value)
                  }
                />
                <Form.Control.Feedback
                  type="invalid"
                  style={{
                    display: formDataError.selectedDescriptionError
                      ? "block"
                      : "none",
                  }}
                >
                  {`O campo ${t(
                    `portalrh.profileData.descricao`
                  )} é de preenchimento obrigatório`}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </div>
        </>
      </Form>
      <Messages />
    </div>
  );
};

export default withNamespaces()(RHProfile);
